{
  "fr": {
    "quiz": {
      "correctAnswers": "{count} correct | {count} correct",
      "finish": "Terminer",
      "incorrectAnswers": "{count} incorrect | {count} incorrect",
      "next": "Continuer",
      "resultsTitle": "Résultat du quiz",
      "step": "Étape {current} sur {total}",
      "tryAgain": "Réessayer"
    }
  }
}
